import { AssetList } from '@unistocks/features/admin/components/asset-management/asset-list';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function AssetsScreen() {
  return (
    <>
      <Head>
        <title>{t('::Assets')}</title>
      </Head>
      <AssetList />
    </>
  );
}
